<template>
	<div class="iframe-container-box container">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<span style="margin-left: 10px">账单管理</span>
						<rs-button @click='$router.back()' style='margin-right:10px ;'>返回</rs-button>
					</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main">
			<rs-row style=" min-height: 620px;">
				<div class="main_header">
					<div class="searchForm" style="margin-top:10px">
						<renderForm v-loading.fullscreen.lock="fullscreenLoading" :list="ruleForm" size="small"
							:formData.sync="searchForm" ref="ruleFormRef" label-width='100%'>
							<rs-form-item label="合同号" slot="mallName">
								<rs-select filterable v-model="searchForm.contractCode" @change="handleSearchs"
									placeholder="请选择">
									<rs-option v-for="item in Contract" :key='item' :label="item" :value="item">
									</rs-option>
								</rs-select>
							</rs-form-item>
							<rs-form-item label="铺位号" slot="ccontractCode" width="70px">
								<rs-select @change="handleSearchsss" filterable v-model="searchForm.boothCode"
									placeholder="请选择">
									<rs-option v-for="item in ccontractCode" :key="item" :label="item" :value="item">
									</rs-option>
								</rs-select>
							</rs-form-item>
							<rs-form-item label="费用项" slot="itemCodes" width="70px">
								<rs-select @change="handleSearchss" filterable v-model="searchForm.itemCode"
									placeholder="请选择">
									<rs-option v-for="item in item" :key="item.itemName" :label="item.itemName"
										:value="item.itemCode">
									</rs-option>
								</rs-select>
							</rs-form-item>
							<rs-form-item label="缴费日期" slot="date">
								<rs-date-picker style='font-size: 8px;' v-model="searchForm.beginDate " type="daterange"
									value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始时间"
									end-placeholder="结束时间" size="mini" class="margin-right-10">
								</rs-date-picker>
							</rs-form-item>
						</renderForm>
						<div style="margin-left: 80%; position: relative;  top: -5px">
							<rs-button type="primary" style="margin-left: 45px" size="small" @click="handleSearch">查询
							</rs-button>
							<rs-button type="text" size="small" @click="clear">重置</rs-button>
						</div>
					</div>
					<div class="contractCode">
						<div>
							<div>待缴总金额（元）</div>
							<div class="contractCodecolor">{{ amountpaid }} <span></span></div>
						</div>
						<div>
							<div>当期缴费金额(元)</div>
							<div>{{ Currentnumber }} <span></span></div>
						</div>
						<div>
							<div>已缴总金额（元）</div>
							<div>{{ PaidAmount }} <span></span></div>
						</div>
						<div>
							<div>缴费记录</div>
							<div>{{numss}}</div>
						</div>
					</div>
				</div>

				<div class="main_main" style="background: #fff; box-shadow: 2px 2px 10px #909090;">

					<rs-tabs style="margin-top: 10px" v-model="activeName" type="card" @tab-click="handleClick">
						<rs-tab-pane label="待缴账单" name="first">

							<!-- <div class="operBox"></div> -->
							<!-- 表格 -->
							<rs-button
								style="float: right; margin-left: 0%;margin-right: 10px;margin-bottom: 10px;margin-top: 50px;"
								@click="export2Excel">下载
							</rs-button>
							<rs-button style="float: right;margin-right: 20px;margin-top: 50px;" type="primary"
								@click="confirmation()">缴费</rs-button>
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable lazy class="row-click" :list="tableData" :columns="tableColumns" border
									ref="multipleTable" @row-dblclick="handleView"
								
									@selection-change="handleSelectionChange">
									<rs-table-column slot="selection" fixed type="selection" width="50px">
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="合同号" slot="contractCode" width="160px">
										<template slot-scope="scope">
											<span @dbclick.stop="toDetails(scope.row.id)"
												style="cursor: pointer">{{ scope.row.contractCode }}</span>
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' show-overflow-tooltip align='center'
										label="铺位号" slot="buildingName">
										<template slot-scope="scope">
											{{ scope.row.boothCode }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="楼栋"
										slot="buildingNames">
										<template slot-scope="scope">
											{{ scope.row.buildingName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="楼层" slot="floorName">
										<template slot-scope="scope">
											{{ scope.row.floorName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="账单周期" slot="statementBeginEndTime">
										<template slot-scope="scope">
											{{ scope.row.statementBeginEndTime }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center'  prop='paymentDue' align='center'
										label="账单应缴日" slot="paymentDue">
										<!-- <template slot-scope="scope">
											{{ scope.row.paymentDue }}
										</template> -->
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="应缴金额（元）"
										slot="unpaidAmount">
										<template slot-scope="scope">
											{{ scope.row.receivableAmount }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="已缴金额（元）"
										slot="paidAmt">
										<template slot-scope="scope">
											{{ scope.row.paidAmt }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="欠缴金额（元）"
										slot="receivableAmount">
										<template slot-scope="scope">
											{{ scope.row.unpaidAmount }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' show-overflow-tooltip align='center'
										label="费用项" slot="itemName">
										<template slot-scope="scope">
											{{ scope.row.itemName }}
										</template>
									</rs-table-column>
									<rs-table-column label="操作" slot="operation" fixed="right" width="240px">
									</rs-table-column>
								</renderTable>

								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="pageNum"
									:page-sizes="[10, 200, 300, 400]" :page-size="pageSize" background
									:prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="total"></rs-pagination>
							</div>
						</rs-tab-pane>
						<rs-tab-pane label="已缴账单" name="second">
							<div class="operBox"></div>
							<!-- 表格 -->
							<rs-button
								style="float: right; margin-left: 0%;margin-right: 10px;margin-bottom: 10px;margin-top: 45px;"
								plain @click="export2Excel">下载
							</rs-button>
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable v-loading="fullscreenLoading" class="row-click" :list="tableDatas"
									:columns="tableColumnss" border ref="multipleTable" @row-dblclick="handleView"
								
									@selection-change="handleSelectionChange">
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="合同号" slot="contractCode">
										<template slot-scope="scope">
											<span @dbclick.stop="toDetails(scope.row.id)"
												style="cursor: pointer">{{ scope.row.contractCode }}</span>
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="铺位号" slot="buildingName">
										<template slot-scope="scope">
											{{ scope.row.boothCode }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="楼栋" slot="buildingNames">
										<template slot-scope="scope">
											{{ scope.row.buildingName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="楼层" slot="floorName">
										<template slot-scope="scope">
											{{ scope.row.floorName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="账单周期" slot="statementBeginEndTime">

										<template slot-scope="scope">
											{{ scope.row.statementBeginEndTime }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center'  prop='paymentDue' align='center'
										show-overflow-tooltip label="付款日期" slot="paymentDue">
										<!-- <template slot-scope="scope">
											{{ scope.row.paymentDue }}
										</template> -->
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="缴纳金额（元）"
										slot="receivableAmount">
										<template slot-scope="scope">
											{{ scope.row.paidAmt }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="费用项" slot="itemName">
										<template slot-scope="scope">
											{{ scope.row.itemName }}
										</template>
									</rs-table-column>
									<rs-table-column label="付款账户" header-align='center' align='center' slot="fu">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="收款账户" header-align='center' align='center' slot="sou">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付流水" header-align='center' align='center' slot="pay">
										<template slot-scope="scope">
											{{scope.row.payType }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付方式" header-align='center' align='center' slot="paytype">
										<template slot-scope="scope">
											{{scope.row.payType }}
										</template>
									</rs-table-column>
								</renderTable>

								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChangess"
									@current-change="handleCurrentChangess" :current-page="pageNums"
									:page-sizes="[10, 200, 300, 400]" :page-size="pageSizes" background
									:prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="totals"></rs-pagination>
							</div>
						</rs-tab-pane>
						<rs-tab-pane label="欠缴账单" name="third">
							<rs-button
								style="float: right; margin-left: 0%;margin-right: 10px;margin-bottom: 10px;margin-top: 45px;"
								plain @click="export2Excel">下载
							</rs-button>
							<rs-button style="float: right;margin-right: 20px;margin-top: 45px;" type="primary"
								@click="confirmation()">缴费</rs-button>

							<!-- 表格 -->
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable v-loading.fullscreen.lock="fullscreenLoading" class="row-click"
									 :list="addEar"
									:columns="addeartableColumns" border ref="multipleTable" @row-dblclick="handleView"
									@selection-change="handleSelectionChange">
									<rs-table-column slot="selection" fixed type="selection" width="50px">
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="合同号" slot="contractCode" width="160px">
										<template slot-scope="scope">
											<span @dbclick.stop="toDetails(scope.row.id)"
												style="cursor: pointer">{{ scope.row.contractCode }}</span>
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' show-overflow-tooltip align='center'
										label="铺位号" slot="buildingName">
										<template slot-scope="scope">
											{{ scope.row.boothCode }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="楼栋"
										slot="buildingNames">
										<template slot-scope="scope">
											{{ scope.row.buildingName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="楼层" slot="floorName">
										<template slot-scope="scope">
											{{ scope.row.floorName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="费用单号" slot="statementNo">
										<template slot-scope="scope">
											{{ scope.row.statementNo }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="商户名称" slot="lessName">
										<template slot-scope="scope">
											{{ scope.row.businessName }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="账单周期" slot="statementBeginEndTime">
										<template slot-scope="scope">
											{{ scope.row.statementBeginEndTime }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' width='120'  align='center'
										prop='paymentDue' label="账单应缴日" slot="paymentDue">
										<!-- <template slot-scope="scope">
											{{ scope.row.paymentDue }}
										</template> -->
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="费用金额(元)"
										slot="receivableAmounts">
										<template slot-scope="scope">
											{{ scope.row.costAmt }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="结算金额(元)"
										slot="receivableAmountss">
										<template slot-scope="scope">
											{{ scope.row.statementAmt }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="应缴金额（元）"
										slot="unpaidAmount">
										<template slot-scope="scope">
											{{ scope.row.receivableAmount }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="已缴金额（元）"
										slot="paidAmt">
										<template slot-scope="scope">
											{{ scope.row.paidAmt }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' label="欠缴金额（元）"
										slot="receivableAmount">
										<template slot-scope="scope">
											{{ scope.row.unpaidAmount }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' show-overflow-tooltip align='center'
										label="费用项" slot="itemName">
										<template slot-scope="scope">
											{{ scope.row.itemName }}
										</template>
									</rs-table-column>
									<rs-table-column label="操作" slot="operation" fixed="right" width="240px">

									</rs-table-column>
								</renderTable>
								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="addEarhandleSizeChange"
									@current-change="addEarhandleCurrentChangess" :current-page="addEarpageNums"
									:page-sizes="[10, 200, 300, 400]" :page-size="addEarpageSizes" background
									:prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="addEartotal">
								</rs-pagination>
							</div>
						</rs-tab-pane>
						<rs-tab-pane label="缴费流水" name="four">


							<div class="operBox"></div>
							<!-- 表格 -->
							<rs-button
								style="float: right; margin-left: 0%;margin-right: 10px;margin-bottom: 10px;margin-top: 45px;"
								plain @click="export2Excel">下载
							</rs-button>

							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable v-loading.fullscreen.lock="fullscreenLoading" class="row-click"
									:list="tableDatass" :columns="tableColumnsss" border ref="multipleTable"
									@row-dblclick="handleView" @selection-change="handleSelectionChange">
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="铺位号" slot="buildingName">
										<template slot-scope="scope">
											{{ scope.row.booths }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="费用单号" slot="statementNo">
										<template slot-scope="scope">
											{{ scope.row.statementNo }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' show-overflow-tooltip align='center'
										label="楼栋" slot="buildingNames">
										<template slot-scope="scope">
											{{ scope.row.buildings }}
										</template>
									</rs-table-column>
									<rs-table-column header-align='center' align='center' show-overflow-tooltip
										label="楼层" slot="floorName">
										<template slot-scope="scope">
											{{ scope.row.floors }}
										</template>
									</rs-table-column>

									<!-- <rs-table-column header-align='center' align='center' show-overflow-tooltip label="商户名称" slot="lessName">
										<template slot-scope="scope">
											{{ bussinessName }}
										</template>
									</rs-table-column> -->
									<rs-table-column label="订单金额(元)" header-align='center' align='center' slot="pay">
										<template slot-scope="scope">
											{{scope.row.orderAmt/100}}
											<!-- {{  }} -->
										</template>
									</rs-table-column>
									<rs-table-column label="支付金额(元)" header-align='center' align='center' slot="pay">
										<template slot-scope="scope">
											{{scope.row.payAmt/100}}
											<!-- {{  }} -->
										</template>
									</rs-table-column>
									<rs-table-column label="订单流水(商户单号)" show-overflow-tooltip header-align='center'
										align='center' slot="dingdan">
										<template slot-scope="scope">
											{{ scope.row.merOrderNo }}
										</template>
									</rs-table-column>
									<rs-table-column label="交易流水" show-overflow-tooltip header-align='center'
										align='center' slot="jiaoyi">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="银行流水" header-align='center' align='center' slot="yinhang">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付方式" :formatter='formatCarModelss' header-align='center'
										prop='payType' align='center' slot="paytype">
										<!-- <template slot-scope="scope">
											{{scope.row.payType }}
										</template> -->
									</rs-table-column>
									<rs-table-column label="付款账户" header-align='center' align='center' slot="fu">
										<template slot-scope="scope">
											{{scope.row.chlSubActNo }}
										</template>
									</rs-table-column>
									<rs-table-column label="收款账户" header-align='center' align='center' slot="sou">
										<template slot-scope="scope">
											{{scope.row.accountNumber }}
										</template>
									</rs-table-column>
									<rs-table-column :formatter='formatCarModels' label="交易状态" prop='tradeStatus'
										header-align='center' align='center' slot="status">
									</rs-table-column>
									<rs-table-column label="支付时间" header-align='center' align='center' slot="times">
										<template slot-scope="scope">
											{{scope.row.transTime}}
										</template>
									</rs-table-column>
									<rs-table-column label="操作" slot="operation" fixed="right">
										<!-- <template slot-scope="scope"> </template> -->
									</rs-table-column>
								</renderTable>
								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChanges"
									@current-change="handleCurrentChanges" :current-page="pageNumss"
									:page-sizes="[10, 200, 300, 400]" :page-size="pageSizess" background
									:prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="totalss"></rs-pagination>
							</div>
						</rs-tab-pane>

					</rs-tabs>
					<!-- 操作栏 -->

				</div>
				<rs-dialog title="确认" :visible.sync="dialogVisible" width="30%">
					<h2 style="text-align: center; margin: 0">
						{{ `确认${confirmType}吗？` }}
					</h2>
					<span slot="footer" class="dialog-footer">
						<rs-button @click="dialogVisible = false">取 消</rs-button>
						<rs-button type="primary" @click="confirm">确 定</rs-button>
					</span>
				</rs-dialog>
				<!-- <change-type-dialog :path="path" :contractId="contractId" :dialogVisible="showChangeTypeDialog" @close="
          () => {
            this.showChangeTypeDialog = false;
          }
        ">
				</change-type-dialog> -->
			</rs-row>
		</div>
		<rs-dialog title="支付" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose"
			:modal-append-to-body="false">
			<h5>选择支付方式：</h5>
			<div style="display: flex;justify-content: space-around;margin-top: 20px;">
				<div @click="saoma" ref='saoma'
					style="width: 28%;border: 1px solid #ccc;text-align: center;padding: 10px;cursor: pointer;">扫码支付
				</div>
				<div @click="duigong" ref='duigong'
					style="width: 28%;border: 1px solid #ccc;text-align: center;padding: 10px;cursor: pointer;">对公打款
				</div>
			</div>
			<!-- <rs-radio-group style="margin-top: 10px;" v-model="paymentType" @change="paymentTypeChange">
				<rs-radio border :label="''+ 0">扫码支付</rs-radio>
				<rs-radio border :label="''+ 1">对公打款</rs-radio>
			</rs-radio-group>
 -->
		</rs-dialog>
		<rs-dialog title='扫码支付' width='30%' :visible.sync="dialogVisibless" :before-close="handleClose">
			<div style="margin-top: 10px;" class="body-img">
				<div id="qrcode" ref="qrcode"></div>
				<div style="text-align: center;height: 50px;line-height: 50px;border-radius: 10px;">请扫描上方二维码进行支付</div>
			</div>
			<div v-if="lnko" style="width:100%;text-align: center;height: 300px ;font-size: 30px;">
				<img style="width: 30%;" src="../assets/支付成功.png" /><br />
				支付成功
				<rs-button @click="dialogVisibles = false" type="primary"
					style="width:100%;float: right;border-radius:20px;margin-top: 80px;">完成</rs-button>
			</div>
			<div slot="footer" class="dialog-footer">
				<rs-button @click="close">取 消</rs-button>
			</div>
		</rs-dialog>
		<rs-dialog title='对公打款' width="30%" :visible.sync="dialogVisiblesss">
			<rs-form :model="paylist">
				<rs-form-item label="商户订单号:">
					{{paylist.merOrderNo}}
				</rs-form-item>
				<rs-form-item label="商户编号:">
					{{paylist.merchantNumber}}
				</rs-form-item>
				<rs-form-item label="子账户名称:">
					{{paylist.subActName}}
				</rs-form-item>
				<rs-form-item label="渠道子账户:">
					{{paylist.chlSubActNo}}
				</rs-form-item>
				<rs-form-item label="缴纳金额:">
					{{paylist.orderAmt}}
				</rs-form-item>
				<rs-form-item label="校验码:">
					{{paylist.checkCode}}
				</rs-form-item>
			</rs-form>
			<div slot="footer" class="dialog-footer">
				<rs-button @click="dialogVisiblesss = false">取 消</rs-button>
			</div>
		</rs-dialog>
	</div>
</template>

<script>
	import VueQr from 'vue-qr'
	//二维码
	import QRCode from 'qrcodejs2';
	import Http from "@/api/api";
	import API from "@/api/pay";
	import utils from "@/utils/utils";
	import Export2Excel from '@/utils/Export2Excel';
	import Blob from '@/utils/Blob';
	// import cc from '../../pub/public/logo.png'
	// import detail from "../resourceManage/resourceDetail";
	export default {
		name: "resourceManage",
		components: {
			QRCode,
			VueQr
		},
		data() {
			return {
				"paymentType": "",
				dialogVisibless: false,
				dialogVisiblesss: false,
				paylist: [],
				pink: true,
				lcnk: false,
				lnko: false,
				activeName: 'first',
				logoSrc: require('../assets/logo.png'),
				url: '',

				dialogVisibles: false,
				value: '',
				PayNum: 0,
				primaryButton: "primary",
				primary: "",
				primaryliushui: "",
				timeDefaultShow: [],
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							},
						},
					],
				},
				showChangeTypeDialog: false,
				path: "",
				itemCodes: [], //费用项
				ccontractCode: [],
				contractId: "",
				addEar: [],
				tableData: [],
				tableDatas: [],
				tableDatass: [],
				Contract: [],
				gettime: '',
				// wholeReceptiontabData: [],
				// wholeRecepData: [],
				// wholeRecepliushuiData: [],
				// tableColumns: [],
				// ruleForm: [],
				// tmpRuleForm: [],
				pageNum: 1,
				pageSize: 10,
				pageNumss: 1,
				pageSizess: 10,
				pageNums: 1,
				pageSizes: 10,
				addEarpageNums: 1,
				addEarpageSizes: 10,
				total: 0,
				totals: 0,
				totalss: 0,
				addEartotal: 0,
				searchForm: {
					contractCode: "",
					beginDate: [],
					shopId: "",
					boothCode: ''
				},
				searchFormClose: true,
				amountpaid: 0,
				confirmType: "",
				dialogVisible: false,
				shopVo: {},
				updateTime: "",
				updateTimes: "",
				Currentnumber: 0,
				PaidAmount: 0,
				categoryList: [],
				contractCodes: [],
				val: '',
				text: '',
				gettimes: '',
				nums: '',
				lonk: true,
				link: false,
				merOrderNo: '',
				timer: '',
				numss: '',
				multipleSelections: [],
				item: [],
				bussinessName: '',
				//加载事件
				fullscreenLoading: false,
			};
		},
		watch: {
			searchMenuName(val) {
				console.log(val);
				this.$refs.resourceTree.filter(val);
			},

		},
		computed: {

		},
		//生命周期 - 创建完成（访问当前this实例）
		created() {

			this.bus.$on("id", (id) => {
				this.nums = id
				console.log(this.nums);
			});
			this.bus.$on("val", (val) => {
				this.val = val
				console.log(this.val);
			});
			this.bus.$on('multipleSelection', (multipleSelection) => {
				this.multipleSelections = multipleSelection
				console.log(this.multipleSelections)
			})
			this.bus.$on('categorystr', (categorystr) => {
				this.categoryList = categorystr
				console.log(this.categoryList)
			})

			this.bus.$on('classifystr', (classifystr) => {
				this.classifystr = classifystr
				console.log(this.classifystr)
			})
			// console.log(this.$route.query.styID);
			// localStorage.setItem('styID', this.$route.query.styID)
			// this.getTime()
			this.shopVo = sessionStorage.getItem("shopVo");
			// debugger
			let {
				auditStatusStr,
				mallCode
			} = this.$route.query;
			this.searchForm.auditStatusStr = auditStatusStr ? [1 * auditStatusStr] : [];
			this.searchForm.mallCode = mallCode || "";
			this.renderPage();
			if (
				this.$route.query.mallCode &&
				this.$route.query.contractStatus &&
				this.$route.query.days
			) {
				this.searchForm.contractStatusStr = Number(
					this.$route.query.contractStatus
				);
				this.searchForm.auditStatusStr = 2; //审核通过
				this.searchForm.mallCode = this.$route.query.mallCode;
				let days = Number(this.$route.query.days);
				if (this.$route.query.contractStatus == 4) {
					//待生效==查近期开始合同
					this.searchForm.beginDate =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				} else if (this.$route.query.contractStatus == 1) {
					//已生效==查近期到期合同
					this.searchForm.endDates =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				}
			}
		},
		watch: { //监听路由变化
			$route(to, from) {
				console.log(to, from)
				// to , from 分别表示从哪跳转到哪，都是一个对象
				// to.path  ( 表示的是要跳转到的路由的地址 eg: /home );
			}
		},
		//生命周期 - 挂载完成（访问DOM元素）
		mounted() {
			// console.log(this.$route.query.itemName)
			// this.item=[]
			// this.item.push({
			// 	itemCode:this.$route.query.itemCode,
			// 	itemName:this.$route.query.itemName
			// })
			this.searchForm.itemCode = this.$route.query.itemCode
			console.log(this.$route.query.time)
			// console.log(this.item)
			this.getUserList()
			// console.log(this.searchForm.itemCode)
			// console.log(isNaN(num) ? 0.00 : parseFloat((num/100).toFixed(2)))
			// this.sol()
			this.handleQueryy()
			// this.handleQuery();
			// // this.Bills()
			this.uillBillRecordList();
			this.amountobepaid();
			this.Currentpayment();
			this.TotalPaidAmount();
			// this.getTotalPaidAmount()
			this.adears()
			this.uillBill()
			this.uillBillPaidAmount()
		},
		activated() {
			this.uillBill()
		},
		methods: {
			getUserList() {
				let lesseeId = utils.getSession("pay").shopVo.shopId;
				let mallCode = utils.getSession("pay").shopVo.mallCode;
				console.log(mallCode)
				//参数lesseeId：商户id，mallCode：项目code
				let params = {
					lesseeId: lesseeId,
					mallCode: mallCode
				}
				API.lesseedetail(params).then((res) => {

					this.bussinessName = res.data.data.lesseeName
					console.log('商户信息详情', this.bussinessName)
				})
			},
			saoma() {
				console.log(this.$refs.saoma)
				this.$refs.saoma.style.border = '1px solid blue'
				this.$router.push({
					path: '/paymentSaoma',
					query: {
						categoryList: this.categoryList,
						classifystr: this.classifystr,
						multipleSelection: this.multipleSelections
					}
				})
			},
			duigong() {
				console.log(this.$refs.duigong)
				this.$refs.duigong.style.border = '1px solid blue'
				this.$router.push({
					path: '/paymentDuigong',
					query: {
						categoryList: this.categoryList,
						classifystr: this.classifystr,
						multipleSelection: this.multipleSelections
					}
				})
			},
			//欠缴
			adearss() {
				this.addDates();
				let updateTime = this.updateTimes;
				let pageNum = this.addEarpageNums;
				let pageSize = this.addEarpageSize;
				console.log(this.shopVo);
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: updateTime,
					// businessId: this.shopVo,
					businessId: this.shopVo,
					paidStatus: 0,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.addEar = res.data.data.list;
							this.addEartotal = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			adears() {
				// this.fullscreenLoading = true;
				// setTimeout(() => {
				// 	this.fullscreenLoading = false;
				// }, 2000);
				this.addDates();
				let updateTime = this.updateTimes;
				let pageNum = this.addEarpageNums;
				let pageSize = this.addEarpageSize;
				console.log(this.shopVo);
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: updateTime,
					// businessId: this.shopVo,
					businessId: this.shopVo,
					paidStatus: 0,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.addEar = res.data.data.list;
							this.addEartotal = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			boothCodes() {
				this.boothCode = this.searchForm.boothCode
			},
			sol() {
				var num = null
				console.log(num / 100)
			},
			formatCarModelss(row, Status) {
				if (row.payType == "SM") {

					return "扫码";
				} else if (row.payType == 'QF') {

					return "对公";
				}
			},
			formatCarModels(row, Status) {
				if (row.tradeStatus == "WAIT") {

					return "未支付";
				} else if (row.tradeStatus == 'SUCCESS') {

					return "已支付";
				} else if (row.tradeStatus == 'PART_PAID') {
					return '部分付款'
				} else if (row.tradeStatus == 'OVER_PAID') {
					return '超收'
				}
			},
			//支付方式
			paymentTypeChange(val) {
				this.paymentType = val
				console.log(val)
				if (Number(this.paymentType) == '0') {
					this.$router.push({
						path: '/paymentSaoma',
						query: {
							categoryList: this.categoryList,
							classifystr: this.classifystr,
							multipleSelection: this.multipleSelections
						}
					})
					// this.lcnk=true
					// this.dialogVisibless=true
					// this.dialogVisibles=false
					// this.pay()
				} else if (Number(this.paymentType) == '1') {
					// this.dialogVisiblesss=true
					// this.dialogVisibles=false
					// this.Pay()
					this.$router.push({
						path: '/paymentDuigong',
						query: {
							categoryList: this.categoryList,
							classifystr: this.classifystr,
							multipleSelection: this.multipleSelections
						}
					})
					// this.lcnk=false
				}
			},
			handleClick(tab, index) {
				console.log(tab.index)
				localStorage.setItem('id', tab.index)
				if (tab.index == '1') {
					this.pink = false
					this.handleSearch()
					// this.amountobepaid(),
					// 	this.Currentpayment(),
					// 	this.TotalPaidAmount()
					// this.uillBillPaidAmount()
					// this.getTotalPaidAmount()
				} else if (tab.index == '2') {
					this.pink = false
					this.handleSearch()
					// this.amountobepaid(),
					// 	this.Currentpayment(),
					// 	this.TotalPaidAmount()
					this.adears()
				} else if (tab.index == '3') {
					this.pink = true
					this.handleSearch()
					// this.amountobepaid(),
					// 	this.Currentpayment(),
					// 	this.TotalPaidAmount()
					this.uillBillRecordList()
				} else {
					this.pink = true
					// this.amountobepaid(),
					// 	this.Currentpayment(),
					// 	this.TotalPaidAmount()
					this.uillBill()
					this.handleSearch()
				}
			},

			// toDetails(id) {
			//   this.$openTabSwitch(
			//     "合同详情",
			//     `/contractNew?actionType=view&contractType=${this.contractType}&contractId=${id}&fromPath=versionList`
			//   );
			// },
			//待缴账单
			wholeReception(e) {
				this.link = false
				this.lonk = true
				console.log(e.target.innerHTML)
				// localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "primary";
				this.primary = "";
				this.primaryliushui = "";
				//待缴账单
				this.Bills();
				// this.tableData = this.wholeReceptiontabData;
			},
			//已缴账单
			wholeRecep(e) {
				console.log(e)
				console.log(e.target.innerHTML)
				// localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "";
				this.primary = "primary";
				this.primaryliushui = "";
				//已缴账单
				this.getTotalPaidAmount();
				// this.tableData = this.wholeRecepData;
			},
			//缴费流水
			wholeRecepliushui(e) {
				this.link = true
				this.lonk = false
				console.log(e.target.innerHTML)
				// localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "";
				this.primary = "";
				this.primaryliushui = "primary";
				//缴费流水
				this.getPayRecordList();
				// this.tableData = this.wholeRecepliushuiData;
			},

			//下载生成excel
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) => {
					switch (v.tradeStatus) {
						case "WAIT":
							v.tradeStatus = "待支付";
							break;
						case "SUCCESS":
							v.tradeStatus = "支付成功";
							break;
						case "PART_PAID":
							v.tradeStatus = "部分付款";
							break;
						case "OVER_PAID":
							v.tradeStatus = "超收";
							break;
					}

					switch (v.payType) {
						case "SM":
							v.payType = "扫码";
							break;
						case "QF":
							v.payType = "对公";
							break;
					}
					// if (v.payAmt !== null && v.payAmt == null) {
					// 	return v.payAmt / 100
					// }
					return filterVal.map((j) => v[j]);
				});
				// return jsonData.map((v) => filterVal.map((j) => v[j]));
			},
			// formatJson(filterVal, jsonData) {
			// 	return jsonData.map((v) => filterVal.map((j) => v[j]));
			// },
			export2Excel() {
				// if(localStorage.getItem('id')=='1'){
				// 	require.ensure([], () => {
				// 		const {
				// 			export_json_to_excel
				// 		} = require('../../../utils/Export2Excel');
				// 		const tHeader = ['铺位号', '楼栋', '楼层','账单周期', '付款日期', '缴纳金额(元)', '费用项', '支付流水', '支付方式','付款账户','收款账户'];
				// 		const filterVal = ['boothCode', 'buildingName', 'floorName', 'statementBeginEndTime','paymentDue','paidAmt','itemName',' ',' ','payType ',' payType'
				// 		];
				// 		const list = this.tableData;
				// 		console.log(list)
				// 		const data = this.formatJson(filterVal, list);
				// 		export_json_to_excel(tHeader, data, '租赁缴费信息表');
				// 	});
				// }else if(localStorage.getItem('id')=='2'){
				// 	require.ensure([], () => {
				// 		const {
				// 			export_json_to_excel
				// 		} = require('../../../utils/Export2Excel');
				// 		const tHeader = ['铺位号', '楼栋', '楼层','支付金额(元)', '订单流水(商户单号)', '交易流水', '银行流水', '支付方式','付款账户','收款账户','交易状态','支付时间'];
				// 		const filterVal = ['boothCode', 'buildingName', 'floorName', 'payAmt/100','merOrderNo',' ',' ','payType',' ', ' ','tradeStatus',' '
				// 		];
				// 		const list = this.tableData;
				// 		console.log(list)
				// 		const data = this.formatJson(filterVal, list);
				// 		export_json_to_excel(tHeader, data, '租赁缴费信息表');
				// 	});
				// }else{
				// require.ensure([], () => {
				// 	const {
				// 		export_json_to_excel
				// 	} = require('../../../utils/Export2Excel');
				// 	const tHeader = ['铺位号', '楼栋', '楼层', '账单周期', '账单应缴日', '应收金额', '费用项', '合同号'];
				// 	const filterVal = ['boothCode', 'buildingName',"floorName",  'statementBeginEndTime',
				// 		'paymentDue', 'unpaidAmount', 'itemName', 'contractCode'
				// 	];
				// 	const list = this.tableData;
				// 	console.log(list)
				// 	const data = this.formatJson(filterVal, list);
				// 	export_json_to_excel(tHeader, data, '租赁缴费信息表');
				// });
				// }

				if (localStorage.getItem('id') == '1') {
					require.ensure([], () => {
						const {
							export_json_to_excel
						} = require('../../../utils/Export2Excel');
						const tHeader = ['铺位号', '楼栋', '楼层', '账单周期', '付款日期', '缴纳金额', '费用项', '合同号'];
						const filterVal = ['boothCode', 'buildingName', 'floorName', 'statementBeginEndTime',
							'paymentDue', 'paidAmt', 'itemName', 'contractCode'
						];
						const list = this.tableDatas;
						console.log(list)
						const data = this.formatJson(filterVal, list);
						if (this.searchForm.itemCode == '1001') {
							export_json_to_excel(tHeader, data, '租赁缴费信息表');
						} else if (this.searchForm.itemCode == '1004') {
							export_json_to_excel(tHeader, data, '物业缴费信息表');
						} else if (this.searchForm.itemCode == '1101,1102') {
							export_json_to_excel(tHeader, data, '水电缴费信息表');
						} else if (this.searchForm.itemCode == '7001') {
							export_json_to_excel(tHeader, data, '定金缴费信息表');
						} else {
							export_json_to_excel(tHeader, data, '账单管理信息表');
						}
					});
				} else if (localStorage.getItem('id') == 2) {
					require.ensure([], () => {
						const {
							export_json_to_excel
						} = require('../../../utils/Export2Excel');
						const tHeader = ['铺位号', '楼栋', '楼层', '费用单号', '商户名称', '账单周期', '账单应收日', '费用金额', '结算金额',
							'应缴金额', '优惠金额', '欠缴金额', '费用项',
							'合同号'
						];
						const filterVal = ['boothCode', 'buildingName', 'floorName', 'statementNo', 'businessName',
							'statementBeginEndTime',
							'paymentDue', 'costAmt', 'statementAmt', 'receivableAmount', 'discountAmount',
							'unpaidAmount',
							'itemName', 'contractCode'
						];
						const list = this.addEar;
						console.log(list)
						const data = this.formatJson(filterVal, list);
						export_json_to_excel(tHeader, data, '欠缴账单信息表');
					});
				} else if (localStorage.getItem('id') == 3) {
					require.ensure([], () => {
						const {
							export_json_to_excel
						} = require('../../../utils/Export2Excel');
						const tHeader = ['铺位号', '楼栋', '楼层', '费用单号', '支付金额(元)', '订单流水', '支付方式', '付款账户',
							'收款账户',
							'交易状态', '支付时间'
						];
						const filterVal = ['booths', 'buildings', 'floors', 'statementNo', 'payAmt',
							'merOrderNo', 'payType', 'chl_sub_act_no ', ' account_number', 'tradeStatus',
							'transTime'
						];
						const list = this.tableDatass;
						console.log(list)
						const data = this.formatJson(filterVal, list);
						if (this.searchForm.itemCode == '1001') {
							export_json_to_excel(tHeader, data, '租赁缴费信息表');
						} else if (this.searchForm.itemCode == '1004') {
							export_json_to_excel(tHeader, data, '物业缴费信息表');
						} else if (this.searchForm.itemCode == '1101,1102') {
							export_json_to_excel(tHeader, data, '水电缴费信息表');
						} else if (this.searchForm.itemCode == '7001') {
							export_json_to_excel(tHeader, data, '定金缴费信息表');
						} else {
							export_json_to_excel(tHeader, data, '账单管理信息表');
						}
					});
				} else {
					require.ensure([], () => {
						const {
							export_json_to_excel
						} = require('../../../utils/Export2Excel');
						const tHeader = ['铺位号', '楼栋', '楼层', '账单周期', '账单应收日', '应缴金额', '已缴金额', '欠缴金额', '费用项', '合同号'];
						const filterVal = ['boothCode', 'buildingName', 'floorName', 'statementBeginEndTime',
							'paymentDue', 'unpaidAmount', 'paidAmt', 'receivableAmount', 'itemName',
							'contractCode'
						];
						const list = this.tableData;
						console.log(list)
						const data = this.formatJson(filterVal, list);
						if (this.searchForm.itemCode == '1001') {
							export_json_to_excel(tHeader, data, '租赁缴费信息表');
						} else if (this.searchForm.itemCode == '1004') {
							export_json_to_excel(tHeader, data, '物业缴费信息表');
						} else if (this.searchForm.itemCode == '1101,1102') {
							export_json_to_excel(tHeader, data, '水电缴费信息表');
						} else if (this.searchForm.itemCode == '7001') {
							export_json_to_excel(tHeader, data, '定金缴费信息表');
						} else {
							export_json_to_excel(tHeader, data, '账单管理信息表');
						}

					});
				}

			},
			toDetails(index, row) {
				console.log(row)
				let ID = row.ID
				this.$router.push({
					path: '/addNews?actionType=view',
					query: {
						ID: ID
					}
				});
			},
			getAfterParamsDate(params) {
				let date = new Date().getTime() + 24 * 60 * 60 * 1000 * params;
				date = utils.dateFormatter(date);
				return date;
			},
			handleSearchs() {
				this.handleQueryys()
				this.handleSearch(),
					this.amountobepaid(),
					this.Currentpayment(),
					this.TotalPaidAmount()
				this.uillBillRecordList()
			},
			handleSearchsss() {
				// this.searchForm.contractCode = ''
				this.handleSearch(),
					this.amountobepaid(),
					this.Currentpayment(),
					this.TotalPaidAmount()
				this.uillBillRecordList()
			},
			handleSearchss() {
				// this.searchForm.contractCode = ''
				this.handleSearch(),
					this.amountobepaid(),
					this.Currentpayment(),
					this.TotalPaidAmount()
				this.uillBillRecordList()

			},
			// 查询
			handleSearch(val) {
				this.handleQueryy()
				console.log(val)
				console.log(localStorage.getItem('id'))
				// this.searchForm.contractCode=val
				var num = 1
				this.bus.$emit('id', num)
				this.pageNum = 1
				// this.handleQuery();
				if (localStorage.getItem('id') == '0' || localStorage.getItem('id') == null) {
					console.log(111)
					this.uillBillRecordList()
					this.uillBill()
					// this.amountpaid=0
					// this.Currentnumber=0,
					// this.PaidAmount=0
					this.amountobepaid()
					this.Currentpayment();
					this.TotalPaidAmount();
				} else if (localStorage.getItem('id') == '1') {
					this.uillBillRecordList()
					this.uillBillPaidAmount()
					// this.amountpaid=0
					// this.Currentnumber=0,
					// // this.PaidAmount=0
					this.amountobepaid()
					this.Currentpayment();
					this.TotalPaidAmount();
				} else if (localStorage.getItem('id') == '2') {
					this.uillBillRecordList()
					this.adears()
					// this.amountpaid=0
					// this.Currentnumber=0,
					// this.PaidAmount=0
					// this.amountobepaid()
					this.Currentpayment();
					this.amountobepaid();
					this.TotalPaidAmount()
				} else if (localStorage.getItem('id') == '3') {
					this.uillBillRecordList()
					// this.amountpaid=0
					// this.Currentnumber=0,
					// this.PaidAmount=0
					this.amountobepaid()
					this.Currentpayment();
					this.TotalPaidAmount();
				}
			},
			clear() {
				// this.item=[]
				// this.ccontractCode=[]
				this.uillBillRecordList()
				// this.amountpaid = 0
				// this.Currentnumber = 0,
				// 	this.PaidAmount = 0
				// this.numss = 0

				this.searchForm = {
					contractCode: "",
					beginDate: [],
					itemCode: ''
				};

			},
			handleQueryys() {
				this.item = []
				this.itemCodes = []
				// this.Contract = []
				this.ccontractCode = []
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize: 999,
					pageNum,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					...this.searchForm,
					paidStatus: '0,1',
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.lists = res.data.data.list
							// this.tableData = res.data.data.list;
							console.log(res.data.data.list)
							// this.total = res.data.data.total;
							for (var i = 0; i < res.data.data.list.length; i++) {
								if (this.Contract.indexOf(res.data.data.list[i].contractCode) === -1) {
									this.Contract.push(res.data.data.list[i].contractCode)
								}

								if (
									this.ccontractCode.indexOf(res.data.data.list[i].boothCode) === -1
								) {
									this.ccontractCode.push(res.data.data.list[i].boothCode);
									// console.log(this.ccontractCode);
								}
							}


							console.log(this.Contract)
							res.data.data.list.map((item) => {
								console.log(item)

								if (this.itemCodes.indexOf(item.itemName) === -1 && this.itemCodes.indexOf(item
										.itemCode) === -1) {
									this.itemCodes.push({
										itemCode: item.itemCode,
										itemName: item.itemName
									})
								}
							})
							// this.item = []
							for (var i = 0; i < this.itemCodes.length; i++) {

								var flag = true;
								for (var j = 0; j < this.item.length; j++) {
									if (this.itemCodes[i].itemCode == this.item[j].itemCode) {
										flag = false;
									};
								};
								if (flag) {
									this.item.push(this.itemCodes[i]);
									console.log(1111, this.item)
								};
							};
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			// 列表API数据合同号
			handleQueryy() {
				this.itemCodes = []
				// this.ccontractCode = []
				// this.item=[]
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize: 999,
					pageNum,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					...this.searchForm,
					paidStatus: '0,1',
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.lists = res.data.data.list
							// this.tableData = res.data.data.list;
							console.log(res.data.data.list)
							// this.total = res.data.data.total;
							// this.Contract = []
							// this.ccontractCode = []
							for (var i = 0; i < res.data.data.list.length; i++) {
								if (this.Contract.indexOf(res.data.data.list[i].contractCode) === -1) {
									this.Contract.push(res.data.data.list[i].contractCode)
								}
								if (
									this.ccontractCode.indexOf(res.data.data.list[i].boothCode) === -1
								) {
									this.ccontractCode.push(res.data.data.list[i].boothCode);
									// console.log(this.ccontractCode);
								}
								// if (this.Billtype.indexOf(res.data.data.list[i].itemName) === -1) {
								// 	this.Billtype.push(res.data.data.list[i].itemName)
								// }
							}
							//                      this.itemCodes=[]
							// this.item=[]
							res.data.data.list.map((item) => {
								console.log(item)

								if (this.itemCodes.indexOf(item.itemName) === -1 && this.itemCodes.indexOf(item
										.itemCode) === -1) {
									this.itemCodes.push({
										itemCode: item.itemCode,
										itemName: item.itemName
									})
								}
							})

							for (var i = 0; i < this.itemCodes.length; i++) {

								var flag = true;
								for (var j = 0; j < this.item.length; j++) {
									if (this.itemCodes[i].itemCode == this.item[j].itemCode) {
										flag = false;
									};
								};

								if (flag) {
									this.item.push(this.itemCodes[i]);
									console.log(1111, this.item)
								};
							};
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//获取已缴费清单
			uillBillPaidAmounts() {
				let pageNum = this.pageNums;
				let pageSize = this.pageSizes;
				console.log(this.shopVo);
				// console.log(this.shopVo.shopId)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					itemCode: '',
					paidStatus: 1,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表已缴账单", res);
							this.tableDatas = res.data.data.list;
							this.totals = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//获取已缴费清单
			uillBillPaidAmount() {
				let pageNum = this.pageNums;
				let pageSize = this.pageSizes;
				console.log(this.shopVo);
				// console.log(this.shopVo.shopId)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					...this.searchForm,
					// itemCode: '',
					paidStatus: 1,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表已缴账单", res);
							this.tableDatas = res.data.data.list;
							this.totals = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//缴费流水
			uillBillRecordList() {
				// this.fullscreenLoading = true;
				// setTimeout(() => {
				// 	this.fullscreenLoading = false;
				// }, 2000);
				let pageNum = this.pageNumss;
				let pageSize = this.pageSizess;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					// ...this.searchForm,
					itemCode: this.searchForm.itemCode,
					booths: this.searchForm.boothCode,
					// paidStatus: 0,
					businessId: this.shopVo,
					// itemCode: '',
					contract_code: this.searchForm.contractCode
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableDatass = res.data.data.list;
							console.log(this.tableDatass)
							this.totalss = res.data.data.total;
							if (res.data.data.total == 0) {
								this.numss = 0
							} else {
								this.numss = this.totalss
							}
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			uillBillRecordLists() {
				// this.fullscreenLoading = true;
				// setTimeout(() => {
				// 	this.fullscreenLoading = false;
				// }, 2000);
				let pageNum = this.pageNumss;
				let pageSize = this.pageSizess;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					// paidStatus: 0,
					businessId: this.shopVo,
					itemCode: ''
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableDatass = res.data.data.list;
							console.log(this.tableDatass)
							this.totalss = res.data.data.total;
							// for(var i in res.data.data.list){
							// 	if(res.data.data.list[i].tradeStatus=='WAIT'){S
							// 	}
							// }
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			// 全部账单
			uillBill() {
				// this.fullscreenLoading = true;
				// setTimeout(() => {
				// 	this.fullscreenLoading = false;
				// }, 2000);
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				this.searchForm.beginDate[1]=this.$route.query.time
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					boothCode: this.searchForm.boothCode,
					contractCode: this.searchForm.contractCode,
					itemCode: this.searchForm.itemCode,
					// ...this.searchForm,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					// itemCode: '',
					paidStatus: 0,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							console.log('合同号111', this.tableData)
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			// 列表API数据
			handleQuerys() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					// itemCode: '',
					paidStatus: 0,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							console.log('合同号', res.data.data.list)
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			turnParams(params) {
				console.log(params);
				if (params.beginDate && params.beginDate.length) {
					params.paymentDueBeginDate =
						typeof params.beginDate[0] == "object" ?
						utils.dateFormatter(params.beginDate[0], "yyyy-MM-dd") :
						params.beginDate[0];
					params.paymentDueEndDate =
						typeof params.beginDate[1] == "object" ?
						utils.dateFormatter(
							typeof params.beginDate[1] == "object" ?
							params.beginDate[1] :
							new Date(params.beginDate[1]),
							"yyyy-MM-dd"
						) :
						params.beginDate[1];
				} else {
					params.paymentDueBeginDate = "";
					params.paymentDueEndDate = "";
				}
				delete params.beginDate;
				if (params.endDates && params.endDates.length) {
					params.beginDate =
						typeof params.endDates[0] == "object" ?
						utils.dateFormatter(params.endDates[0], "yyyy-MM-dd") :
						params.endDates[0];
					params.endDate =
						typeof params.endDates[1] == "object" ?
						utils.dateFormatter(params.endDates[1], "yyyy-MM-dd") :
						params.endDates[1];
				} else {
					params.beginDate = "";
					params.endDate = "";
				}
				delete params.endDates;
				console.log(params);
				return params;
			},
			//获取已缴费清单
			getTotalPaidAmount() {
				let pageNum = this.pageNums;
				let pageSize = this.pageSizes;
				console.log(this.shopVo);
				// console.log(this.shopVo.shopId)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					itemCode: '1001',
					paidStatus: 1,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表已缴账单", res);
							this.tableDatas = res.data.data.list;
							this.totals = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//获取未缴费清单  （未缴费加上一个月时间）
			Bills() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo);
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					// shopId: this.shopVo,
					businessId: this.shopVo,
					itemCode: '1001',
					// paidStatus: 0,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表111", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//缴费流水
			getPayRecordList() {
				let pageNum = this.pageNumss;
				let pageSize = this.pageSizess;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					// paidStatus: 0,
					businessId: this.shopVo,
					itemCode: '1001'
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableDatass = res.data.data.list;
							console.log(this.tableDatass)
							this.totalss = res.data.data.total;
							// for(var i in res.data.data.list){
							// 	if(res.data.data.list[i].tradeStatus=='WAIT'){

							// 	}
							// }
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			getPayRecordLists() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
					itemCode: '1001'
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							console.log(this.tableData)
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//获取待缴费金额
			amountobepaid() {
				let phone = utils.getSession("shopVo");
				this.searchForm.beginDate[1]=this.$route.query.time
				let params = {
					businessId: phone,
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					...this.searchForm,
					paidStatus: 0,

					// contractCode: this.searchForm.contractCode,
				};
				console.log(params)
				params = this.turnParams(params);
				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表222", res);
						if (res.data.data == null) {
							this.amountpaid = 0
						} else {
							this.amountpaid = res.data.data;
						}

					}
				});
			},
			addDates() {
				// const nowDate = new Date();
				// const date = {
				//   year: nowDate.getFullYear(),
				//   month: nowDate.getMonth() + 2,
				//   date: nowDate.getDate(),
				// };
				// const newmonth = date.month > 10 ? date.month : "0" + date.month;
				// const day = date.date > 10 ? date.date : "0" + date.date;
				// const hh = new Date().getHours();
				// const mf = new Date().getMinutes()
				// const ss = new Date().getSeconds()
				var _this = this;
				// let yy = new Date().getFullYear();
				// let mm = new Date().getMonth()+1;
				// let dd = new Date().getDate();
				// let hh = new Date().getHours();
				// let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
				// let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
				var d = new Date();
				var ye = d.getFullYear();
				var mo = (d.getMonth() + 1).toString().padStart(2, "0");
				var da = d.getDate().toString().padStart(2, "0");
				var updateTime = ye + "-" + mo + "-" + da;
				// alert(time);
				// _this.updateTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
				_this.updateTimes = updateTime;
				console.log(updateTime);
				// this.updateTime = date.year + "-" + newmonth + "-" + day + '' + hh;
			},
			addDate() {
				// const nowDate = new Date();
				// const date = {
				//   year: nowDate.getFullYear(),
				//   month: nowDate.getMonth() + 2,
				//   date: nowDate.getDate(),
				// };
				// const newmonth = date.month > 10 ? date.month : "0" + date.month;
				// const day = date.date > 10 ? date.date : "0" + date.date;
				// const hh = new Date().getHours();
				// const mf = new Date().getMinutes()
				// const ss = new Date().getSeconds()
				var _this = this;
				// let yy = new Date().getFullYear();
				// let mm = new Date().getMonth()+1;
				// let dd = new Date().getDate();
				// let hh = new Date().getHours();
				// let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
				// let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
				var d = new Date();
				var ye = d.getFullYear();
				var mo = (d.getMonth() + 2).toString().padStart(2, '0');
				var mos = (d.getMonth() + 1).toString().padStart(2, '0');
				var da = d.getDate().toString().padStart(2, '0');
				var updateTime = ye + '-' + mo + '-' + da;
				var updateTimes = ye + '-' + mos + '-' + da;
				// alert(time);
				// _this.updateTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
				_this.updateTime = updateTime
				_this.gettimes = updateTimes
				console.log(updateTime)
				// this.updateTime = date.year + "-" + newmonth + "-" + day + '' + hh;
			},

			//获取当期缴费金额   当前时间加一个月
			Currentpayment() {
				let phone = utils.getSession("shopVo");
				this.addDate();
				let updateTime = this.updateTime;
				let updateTimes = this.gettimes;
				console.log(updateTime);
				// let time = Number(supdateTime)
				// console.log(time)
				let params = {
					businessId: phone,
					paymentDueBeginDate: updateTimes,
					paymentDueEndDate: updateTime,
					...this.searchForm,
					paidStatus: 1,
				};
				console.log(params)
				// params = this.turnParams(params);
				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						if (res.data.data == null) {
							this.Currentnumber = 0
						} else {
							this.Currentnumber = res.data.data;
						}

					}
				});
			},
			//获取已缴费金额
			TotalPaidAmount() {
				let params = {
					paymentDueBeginDate: this.searchForm.beginDate[0],
					paymentDueEndDate: this.searchForm.beginDate[1],
					...this.searchForm,
					paidStatus: 1,
					businessId: this.shopVo,
					// itemCode: ''
				};
				API.getTotalPaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表111", res);
						if (res.data.data == null) {
							this.PaidAmount = 0
						} else {
							this.PaidAmount = res.data.data;
						}
					}
				});
			},
			//获取
			handleSelectionChange(val) {
				this.bus.$emit('val', val)
				this.bus.$emit('multipleSelection', val)
				this.multipleSelection = val;
				console.log(this.multipleSelection);
				var categorystr = "";
				var classifystr = "";
				var classirerstr = "";
				this.multipleSelection.forEach(function(c) {
					categorystr += c.statementNo + ",";
					classifystr += c.itemCode + ",";
					classirerstr += c.businessId + ",";
				});
				console.log(categorystr.length)
				categorystr = categorystr.substring(0, categorystr.length - 1);
				classifystr = classifystr.substring(0, classifystr.length - 1);
				classirerstr = classirerstr.substring(0, classirerstr.length - 1);
				console.log(classirerstr);
				// this.categoryList = categorystr.split(",");
				// this.classifystr = classifystr.split(",");
				// this.classirerslist = classirerstr.split(",");
				this.categoryList = categorystr;
				this.classifystr = classifystr;
				this.classirerslist = classirerstr;
				this.bus.$emit('categorystr', categorystr)
				this.bus.$emit('classifystr', classifystr)
				// console.log(str)
				// console.log(this.categoryList);
				// console.log(this.classifystr);
				// console.log(this.classirerslist);
			},
			//生成二维码
			qrcodeScan() {
				//这里是为了 每次进入方法就删除上一张二维码
				console.log(this.$refs.qrcode)
				this.$refs.qrcode.innerHTML = ''
				// document.getElementById("qrcode").innerHTML = "";
				// 生成二维码
				// console.log(this.url);
				var qrcode = new QRCode("qrcode", {
					text: this.url, // 这里为动态二维码地址
					width: 150,
					height: 150,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				});
			},
			//扫码
			pay() {

				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.categoryList,
					itemCode: this.classifystr,
					businessId: phone,
				};
				API.unifiedPreOrder7011(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						// this.dialogVisibless = true,
						this.url = res.data.data.js_pay_url
						this.$nextTick(() => {
							this.qrcodeScan()
						})
						this.merOrderNo = res.data.data.merOrderNo
						this.timer = setInterval(() => {
							this.getOrderlist()
						}, 3000)
						// window.open(res.data.data.pc_cashier_url);

					} else {}
				});
			},
			//对公
			Pay() {
				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.categoryList,
					itemCode: this.classifystr,
					businessId: phone,
				};
				API.unifiedPreOrder9004(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						this.paylist = res.data.data
						// window.open(res.data.data.pc_cashier_url);	
					}
				});
			},
			//缴费确认
			confirmation() {
				if (this.val.length == 0) {
					this.$message.error("您还未勾选需要缴费的信息");
				} else {
					this.dialogVisibles = true
					this.paymentTypeChange()

				}
			},
			getOrderlist() {
				let params = {
					merOrderNo: this.merOrderNo,
				};
				API.getPayRecordByMerOrderNo(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res.data.data.tradeStatus);
						if (res.data.data.tradeStatus == "SUCCESS") {
							this.lcnk = false,
								this.lnko = true
							this.handleQuery()
						} else {
							this.lcnk = true,
								this.lnko = false
						}
					}
				});
			},
			handleClose(done) {
				this.$confirm('确认取消支付？')
					.then(_ => {
						done();
						//点击关闭二维码，清除定时器
						clearInterval(this.timer)
					})
					.catch(_ => {});
			},
			close() {
				this.dialogVisibless = false
				clearInterval(this.timer)
			},
			//商户订单编号获取缴费流水
			//   getOrderList(){
			// 	let params = {
			// 		merOrderNo:this.merOrderNo,
			// 	};
			// 	API.getPayRecordByMerOrderNo(params).then((res) => {
			// 		if (res.data.code == 200) {
			// 			if(res.data.data.tradeStatus=="SUCCESS"){
			// 				this.lcnk=false,
			// 				this.lnko=true
			// 				this.handleQuery()
			// 			}else{
			// 		this.lcnk=true,
			// 		this.lnko=false
			// 	}
			// 			// var num;
			// 			// console.log(num++,res)
			// 			console.log("获取合同列表", res);
			// 		}
			// 	});
			// },
			// 查看
			handleView(row) {
				console.log(row);
				// if (!this.$btnResource()["zyht-ck"]) {
				//   this.$message.warning("暂无查看权限");
				//   return;
				// }
				// this.$openTabSwitch(
				//   "自营合同详情",
				//   `/contractNew?actionType=view&contractType=norm&contractId=${row.id}&fromPath=contractList`
				// );
				// this.$router.push({path: '/contract', query: {actionType:'view',contractType:'norm',contractId:row.id}})
			},
			// 历史版本
			// toVersion(scope) {
			//   this.$openTabSwitch(
			//     "自营合同历史版本",
			//     `/versionList?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList`
			//   );
			// },
			// 退租
			// toTuizu(scope) {
			//   this.$openTabSwitch(
			//     "自营合同退租",
			//     `/tuizu?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList&id=${scope.row.id}`
			//   );
			// },
			// 合同终止
			// toStop(scope) {
			//   let { id } = scope.row;
			//   this.$openTabSwitch(
			//     "自营合同终止",
			//     `/refundEdit?contractId=${id}&jumpType=add`
			//   );
			// },
			// 新增
			// handleCreate(scope, actionType, typeName) {
			//   let id = scope ? scope.row.id : "",
			//     contractCode = scope ? scope.row.contractCode : "";
			//   let title = `${typeName}自营合同`;
			//   if (actionType == "renew") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else if (actionType == "stop") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}`
			//     );
			//   }
			// },
			// 审核
			// toApply(flowNo) {
			//   this.$getZjBpmViewUrl(flowNo);
			//   // this.$openTabSwitch2(
			//   //   "",
			//   //   `/workflow/#/flowDetail?processInstanceId=${id}&isBack=true`
			//   // );
			// },
			// 删除  作废
			// openDialog(scope, type) {
			//   this.contractId = scope.row.id;
			//   this.confirmType = type;
			//   this.dialogVisible = true;
			// },
			// 删除  作废  confirm
			async confirm() {
				let res = null;
				if (this.confirmType == "删除") {
					res = await API.delete({
						id: this.contractId
					});
				} else if (this.confirmType == "作废") {
					res = await API.cancel({
						id: this.contractId
					});
				}
				if (res.data.code == 200) {
					this.dialogVisible = false;
					this.handleQuery();
					this.$message.success(`${this.confirmType}成功`);
				}
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.uillBill();
			},
			addEarhandleSizeChange(val) {
				this.addEarpageSize = val;
				this.adears();
			},
			handleSizeChangess(val) {
				this.pageSizes = val;
				this.uillBillPaidAmount();
			},
			handleSizeChanges(val) {
				this.pageSizess = val;
				this.uillBillRecordList();
			},
			addEarhandleCurrentChangess(val) {
				this.addEarpageNums = val;
				if (this.searchForm.beginDate == "") {
					this.adears()
				} else
				if (this.nums == 1) {
					this.adears()
				} else {
					if (this.searchForm.beginDate !== "") {
						this.adearss()
					}
				}


			},
			handleCurrentChangess(val) {
				this.pageNums = val;
				if (this.searchForm.beginDate == "") {
					this.uillBillPaidAmount()
				} else
				if (this.nums == 1) {
					this.uillBillPaidAmount()
				} else {
					if (this.searchForm.beginDate !== "") {
						this.uillBillPaidAmounts()
					}
				}


			},
			handleCurrentChange(val) {
				this.pageNum = val;
				if (this.searchForm.beginDate == "") {
					this.uillBill()
				} else
				if (this.nums == 1) {
					this.uillBill();
				} else {
					if (this.searchForm.beginDate !== "") {
						this.handleQuerys()
					}
				}


			},
			handleCurrentChanges(val) {
				this.pageNumss = val;
				if (this.searchForm.beginDate == "") {
					this.uillBillRecordList()
				} else
				if (this.nums == 1) {
					this.uillBillRecordList()
				} else {
					if (this.searchForm.beginDate !== "") {
						this.uillBillRecordLists()
					}
				}


			},
			changeSearchFormClose() {
				this.searchFormClose = !this.searchFormClose;
				if (this.searchFormClose) {
					this.ruleForm = this.ruleForm.filter((item) => {
						return !item.allowHide;
					});
				} else {
					this.ruleForm = this.tmpRuleForm;
				}
			},
			mallChange(val) {
				// console.log(val )
				this.$set(this.searchForm, "mallCode", val.mallCode);
				this.$set(this.searchForm, "mallName", val.mallName);
				this.handleQuery();
			},
			changeFloor(val) {
				// console.log(val);
				this.searchForm.buildingId = _.uniq(
					val.map((item) => item.buildingId)
				)[0];
				this.searchForm.floorId = _.uniq(val.map((item) => item.floorId))[0];
			},
			// 渲染搜索条件和table
			renderPage() {
				this.tmpRuleForm = [{
						slot: "mallName"
					},
					{
						slot: "ccontractCode",
					},
					{
						slot: 'itemCodes'
					},
					{
						slot: 'date'
					}
				];
				this.ruleForm = this.tmpRuleForm.filter((item) => {
					return !item.allowHide;
				});
				this.addeartableColumns = [{
						width: 40,
						type: "selection",
						fixed: true,
					},
					{
						type: 'index',
						label: "序号",

						// minWidth: "50px",
						// sortable: true,
					},

					// {
					// 	slot: 'boothCode',
					// 	// minWidth: "120px",
					// 	// sortable: true,
					// },
					{
						slot: 'buildingName'
						// label: "楼栋",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "buildingNames"
					},
					{
						slot: 'floorName'
						// prop: "floorName",
						// label: "楼层",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'statementNo'
					},
					{
						slot: 'lessName'
					},
					{
						slot: 'statementBeginEndTime'
						// prop: "statementBeginEndTime",
						// label: "账单周期",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "paymentDue"
						// prop: "paymentDue",
						// label: "账单应收日",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'receivableAmounts'
					},
					{
						slot: "receivableAmountss"
					},
					{
						slot: 'unpaidAmount'
						// prop: "receivableAmount",
						// label: "应收金额（元）",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						prop: "discountAmount",
						label: "优惠金额",
						align: 'center',
						// minWidth: "120px",
						// sortable: true,
					},

					{
						slot: 'receivableAmount'
					},
					{
						// prop: "itemName",
						// label: "费用项",
						slot: 'itemName'
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "contractCode",
					},
					// {
					// 	slot: "pay",
					// },
					// {
					// 	slot: 'dingdan'
					// },
					// {
					// 	slot: 'jiaoyi'
					// },
					// {
					// 	slot: 'yinhang'
					// },
					// {
					// 	slot: 'paytype'
					// },
					// {
					// 	slot: 'fu'
					// },
					// {
					// 	slot: 'sou'
					// },
					// {
					// 	slot: 'status'
					// },
					// {
					// 	slot: 'times'
					// },

				];
				this.tableColumns = [{
						width: 40,
						type: "selection",
						fixed: true,
					},
					{
						type: 'index',
						label: "序号",
						// minWidth: "50px",
						// sortable: true,
					},

					// {
					// 	slot: 'boothCode',
					// 	// minWidth: "120px",
					// 	// sortable: true,
					// },
					{
						slot: 'buildingName'
						// label: "楼栋",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "buildingNames"
					},
					{
						slot: 'floorName'
						// prop: "floorName",
						// label: "楼层",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'statementBeginEndTime'
						// prop: "statementBeginEndTime",
						// label: "账单周期",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "paymentDue"
						// prop: "paymentDue",
						// label: "账单应收日",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'unpaidAmount'
						// prop: "receivableAmount",
						// label: "应收金额（元）",
						// // minWidth: "120px",
						// sortable: true,
					},

					{
						slot: 'paidAmt'
					},
					{
						slot: 'receivableAmount'
					},
					{
						// prop: "itemName",
						// label: "费用项",
						slot: 'itemName'
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "contractCode",
					},
					// {
					// 	slot: "pay",
					// },
					// {
					// 	slot: 'dingdan'
					// },
					// {
					// 	slot: 'jiaoyi'
					// },
					// {
					// 	slot: 'yinhang'
					// },
					// {
					// 	slot: 'paytype'
					// },
					// {
					// 	slot: 'fu'
					// },
					// {
					// 	slot: 'sou'
					// },
					// {
					// 	slot: 'status'
					// },
					// {
					// 	slot: 'times'
					// },

				];
				this.tableColumnss = [{
						width: 40,
						type: "selection",
						fixed: true,
					},
					{
						type: 'index',
						label: "序号",
						// minWidth: "50px",
						// sortable: true,
					},

					// {
					// 	slot: 'boothCode',
					// 	// minWidth: "120px",
					// 	// sortable: true,
					// },
					{
						slot: 'buildingName'
						// label: "楼栋",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "buildingNames"
					},
					{
						slot: 'floorName'
						// prop: "floorName",
						// label: "楼层",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'statementBeginEndTime'
						// prop: "statementBeginEndTime",
						// label: "账单周期",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "paymentDue"
						// prop: "paymentDue",
						// label: "付款日期",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'receivableAmount'
						// prop: "receivableAmount",
						// label: "缴纳金额（元）",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						// prop: "itemName",
						// label: "费用项",
						slot: 'itemName'
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "contractCode",
					},
					// {
					// 	slot: 'fu'
					// }, {
					// 	slot: 'sou'
					// }, {
					// 	slot: 'pay'
					// }, {
					// 	slot: 'paytype'
					// }
					// {
					// 	slot: "pay",
					// },
					// {
					// 	slot: 'dingdan'
					// },
					// {
					// 	slot: 'jiaoyi'
					// },
					// {
					// 	slot: 'yinhang'
					// },
					// {
					// 	slot: 'paytype'
					// },
					// {
					// 	slot: 'fu'
					// },
					// {
					// 	slot: 'sou'
					// },
					// {
					// 	slot: 'status'
					// },
					// {
					// 	slot: 'times'
					// },

				];
				this.tableColumnsss = [{
						width: 40,
						type: "selection",
						fixed: true,
					},
					{
						type: 'index',
						label: "序号",
						// minWidth: "50px",
						// sortable: true,
					},

					// {
					// 	slot: 'boothCode',
					// 	// minWidth: "120px",
					// 	// sortable: true,
					// },
					{
						slot: 'buildingName'
						// label: "楼栋",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "buildingNames"
					},
					{
						slot: 'floorName'
						// prop: "floorName",
						// label: "楼层",
						// // minWidth: "120px",
						// sortable: true,
					},
					// {
					// 	slot:'statementNo'
					// },
					{
						slot: 'lessName'
					},
					{
						slot: 'statementNo'
					},
					{
						slot: 'pay'
						// prop: "statementBeginEndTime",
						// label: "账单周期",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "dingdan"
						// prop: "paymentDue",
						// label: "付款日期",
						// minWidth: "120px",
						// sortable: true,
					},
					// {
					// 	slot: 'jiaoyi'
					// 	// prop: "receivableAmount",
					// 	// label: "缴纳金额（元）",
					// 	// // minWidth: "120px",
					// 	// sortable: true,
					// },
					// {
					// 	// prop: "itemName",
					// 	// label: "费用项",
					// 	slot: 'yinhang'
					// 	// minWidth: "120px",
					// 	// sortable: true,
					// },
					{
						slot: 'paytype'
					},
					{
						slot: "fu",
					},
					{
						slot: 'sou'
					}, {
						slot: 'status'
					}, {
						slot: 'times'
					}
					// {
					// 	slot: "pay",
					// },
					// {
					// 	slot: 'dingdan'
					// },
					// {
					// 	slot: 'jiaoyi'
					// },
					// {
					// 	slot: 'yinhang'
					// },
					// {
					// 	slot: 'paytype'
					// },
					// {
					// 	slot: 'fu'
					// },
					// {
					// 	slot: 'sou'
					// },
					// {
					// 	slot: 'status'
					// },
					// {
					// 	slot: 'times'
					// },

				];
			},
		},
	};
</script>
<style lang="less" scoped>
	.rs-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		background-color: #ffffff;
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	@import "../../organizationManage/style/index.less";

	/deep/ .rs-table__row {
		&:hover {
			cursor: pointer;
		}
	}

	/deep/ .current-row {
		.resourceCode {
			color: #2ba3ff;
		}
	}

	.contractCode {
		height: 90px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-around;
		background: #f3f7ff;
	}

	.contractCode div {
		text-align: center;
		line-height: 2;
		font-size: 16px;
		margin: 5px;
	}

	.contractCodecolor {
		color: burlywood;
		font-size: 16px;
	}

	.contractCodecolor span {
		font-size: 14px;
	}

	.main {
		margin-top: 10px;
		padding: 10px;
	}

	.container {
		height: 100%;
		// background-color: #ebebeb;
	}

	.main_header {
		background: white;
		padding: 10px;
		box-shadow: 2px 2px 10px #909090;
	}

	#qrcode {
		width: 150px;
		height: 150px;
		margin: 0 auto;
		position: relative;
	}

	#qrcode canvas+img {
		width: 100%;
		height: 100%;
	}

	.qrcode__logo {
		width: 50px;
		height: 50px;
		border-radius: 10%;
		border: 1px solid #fff;
		position: absolute;
		margin: auto;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
	}

	.tabControlBtn {
		display: none;
	}
</style>
